// features/bookmarks/MoveToFolderMenu.tsx — per-card folder picker.

import { useState } from 'react';
import styled from 'styled-components';
import { IconButton, Popover } from '@/ui';
import type { BookmarkFolder } from '@/core/models/bookmark';

export interface MoveToFolderMenuProps {
  currentFolderId: string;
  folders: BookmarkFolder[];
  onMove: (folderId: string) => void;
}

const Menu = styled.div`min-width: 180px; display: flex; flex-direction: column;`;
const Item = styled.button<{ $active: boolean }>`
  display: flex; align-items: center; justify-content: space-between; gap: 8px;
  width: 100%; padding: 8px 10px; border: none; background: transparent; cursor: pointer;
  border-radius: ${({ theme }) => theme.radius.sm};
  font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textPrimary};
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  &:hover { background: ${({ theme }) => theme.color.glassBorder}; }
`;

export function MoveToFolderMenu({ currentFolderId, folders, onMove }: MoveToFolderMenuProps) {
  const [open, setOpen] = useState(false);
  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger={<IconButton icon="folder" label="Move to folder" size={16} />}
    >
      <Menu>
        {folders.map((f) => (
          <Item
            key={f.id}
            type="button"
            role="menuitemradio"
            aria-checked={f.id === currentFolderId}
            $active={f.id === currentFolderId}
            onClick={() => { onMove(f.id); setOpen(false); }}
          >
            {f.name}
          </Item>
        ))}
      </Menu>
    </Popover>
  );
}
